<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>プラスの氣を送る</template>
      <template v-slot:annotation>
        あなたの仲間を表示します。プラスの氣を送ってください！！
      </template>
    </PageHeader>

    <v-row class="text-center px-3">
      <v-col cols="12" md="4">
        <FormInputComponent
          label="氏名"
          v-model="searchKey"
          :length="10"
          :counter="10"
        />
      </v-col>
      <v-col cols="12" md="4">
        <Button @click="get_member()" color="primary" :disabled="loading"
          >検索</Button
        >
      </v-col>
    </v-row>

    <v-row v-show="!loading" class="px-3">
      <v-col
        v-for="item in items"
        cols="12"
        md="3"
        align="center"
        :key="item.title"
        @click="onClickSendOpen(item)"
      >
        <Avatar :src="item.USER_AVATER" :size="150" class="mb-2" />

        <h3>{{ item.USER_FAMILY_NAME }}{{ item.USER_FIRST_NAME }}</h3>

        <div class="text-left">
          <Chip color="#BD8854" icon="mdi-label" lavel="役職">
            {{ item.POSITION_NAME }}
          </Chip>

          <Chip color="#BD8854" icon="mdi-label" lavel="勤務開始日">
            {{ item.START_WORKING_AT }}
          </Chip>
        </div>
      </v-col>

      <EmptyState
        v-if="!items.length"
        imagePath="empty-state-send.svg"
        size="150"
        title="プラスの氣を送ることができる相手は見つかりませんでした"
      >
        <p>
          検索時の氏名が正しく入力されているかご確認ください。<br />
          まだ送信できるユーザーが存在しない場合、まずは管理メニューよりスタッフの登録をしましょう。<br />
          あなたが管理者でない場合、いますぐあなたの組織の管理者に依頼しましょう。
        </p>
      </EmptyState>
    </v-row>

    <Loader :loading="loading" />

    <send ref="send"></send>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import config from '../../../const.js';
import send from '@/components/pages/Encouragements/SendDialog.vue';
import message from '../../../message.js';
import { getSessionStorageItem, makeDateFormatStr } from '../../../common.js';
export default {
  components: {
    send,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'プラスの氣を送る',
          route: 'EncouragementsSend',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      searchKey: '',

      // パラメータ取得
      organizationName: '',
      loginName: '',
      dispPosition: '',
      sessionId: '',
      // 自分自身のプラスの氣取得
      items: [],
    };
  },
  created() {
    // プラスの氣取得
    this.get_member();
  },

  methods: {
    onClickSendOpen(item) {
      // システム管理者の権限チェック
      let userInfo = getSessionStorageItem();
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        let infoStr = 'システム管理者はプラスの氣を操作できません。';
        this.$refs.dialog.open('info', infoStr);
        return;
      }

      this.$refs.send.open(
        item.ORGANIZATION_KEY,
        item.USER_ID,
        item.USER_NAME,
        item.USER_NAME_FURIGANA,
        item.POSITION_NAME,
        item.USER_AVATER,
        item.START_WORKING_AT,
        config.REPLY_FLG_OFF,
        { color: 'red' }
      );
    },

    async get_member() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/members/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // プラスの氣データ取得
          vm.items = [];

          // 検索データによるデータ削除
          for (var i = 0; i < response.data.length; i++) {
            if (this.searchKey != null && this.searchKey.trim()) {
              if (response.data[i].USER_NAME.search(this.searchKey) > -1) {
                vm.items = vm.items.concat(response.data[i]);
              }
            } else {
              vm.items = vm.items.concat(response.data[i]);
            }
          }
          // アバター接続URL作成
          for (var j = 0; j < vm.items.length; j++) {
            vm.items[j].USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              vm.items[j].USER_AVATER +
              '?' +
              moment().format('YYYYMMDDHHmmss');
            vm.items[j].START_WORKING_AT = makeDateFormatStr(
              vm.items[j].START_WORKING_AT,
              '/',
              '/',
              ''
            );
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_MEMBER_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
